import { competenciaLimiteRemuneracaoEditavel, tipoFiliadoMap } from "./constants";
import { converterCompetenciaEmData, obterQuantidadeDeMesesEntreDatas } from "../../../shared/helper/utilitarioData";
import { getTodosPeriodosEditaveis, montarJsonNovoVinculo } from "../../simulador/public/service";
import isDate from 'lodash/isDate';
import isEmpty from 'lodash/isEmpty';

import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat' 

dayjs.extend(customParseFormat);
dayjs.extend(isSameOrBefore);

export const obterItensDosTiposDeVinculos = () => [
  { value: "EMPREGADO", label: "Empregado" },
  {
    value: "EMPREGADO_DOMESTICO",
    label: "Empregado Doméstico",
  },
  {
    value: "CONTRIBUINTE_INDIVIDUAL_AUTONOMO",
    label: "Contribuinte Individual / Autônomo",
  },
  { value: "FACULTATIVO", label: "Facultativo" },
  {
    value: "TRABALHADOR_AVULSO",
    label: "Trabalhador Avulso",
  },
  { value: "TRABALHADOR_RURAL", label: "Trabalhador Rural" },
  {
    value: "SERVIDOR_PUBLICO_EFETIVO_RPPS",
    label: "Servidor Público Efetivo (RPPS)",
  },
  {
    value: "SERVIDOR_PUBLICO_CONTRATADO_COMISSIONADO",
    label: "Servidor Público Contratado / Comissionado",
  },
  { value: "SERVICO_MILITAR", label: "Serviço Militar" },
  { value: "OUTROS", label: "Outros" },
];

export const obterItensDosTiposDeRegimeEspecial = () => [
  {
    value: "",
    label: "Período comum",
  },
  {
    value: "PERIODO_ATIVIDADE_ESPECIAL",
    label: "Período de Atividade Especial",
  },
  {
    value: "PERIODO_PROFESSOR",
    label: "Período como Professor",
  },
];

export const obterDescricaoTipoRegimeEspecial = (tipoRegime) => {
  const regimeEncontrado = obterItensDosTiposDeRegimeEspecial().find(tipo => tipo.value === tipoRegime)
  return regimeEncontrado ? regimeEncontrado.label : '';
}

export const obterItensTipoRegimeEspecialRelacaoTrabalhista = (tipoVinculoRelacaoTrabalhista, especie) => {
  if (!tipoVinculoRelacaoTrabalhista) {
    return [];
  }

  const especieAposentandoriaPorIdade = 41;
  let itensTipoRegimeEspecial = obterItensDosTiposDeRegimeEspecial();
  if (especie && especie === especieAposentandoriaPorIdade) {
    // não permite professor
    itensTipoRegimeEspecial = itensTipoRegimeEspecial.filter(regime => regime.value !== 'PERIODO_PROFESSOR');
  }
  switch (tipoVinculoRelacaoTrabalhista) {
    case 'SERVIDOR_PUBLICO_EFETIVO_RPPS':
      return itensTipoRegimeEspecial.filter(regime => regime.value === 'PERIODO_PROFESSOR' || regime.value === "");
    case 'CONTRIBUINTE_INDIVIDUAL_AUTONOMO':
    case 'TRABALHADOR_AVULSO':
      return itensTipoRegimeEspecial.filter(regime => regime.value === 'PERIODO_ATIVIDADE_ESPECIAL' || regime.value === "");
    default:
      return itensTipoRegimeEspecial;
  }
}

/* avaliar um local comum */
export const isDataFutura = (dataISO) => {
  const dataMoment = dayjs(dataISO);
  return dataMoment.isAfter(dayjs());
}

export const isPeriodoValido = (dataInicioISO, dataTerminoISO) => {
  
  const inicio = dayjs(dataInicioISO);
  const fim = dayjs(dataTerminoISO);
  return inicio.isSameOrBefore(fim);
}

export const deveGerarOuAtualizarRemuneracoes = (vinculo) => {
  const { dataInicio, dataFim } = vinculo;
  const inicio = obterDataDeInicioOuMenorDataInicioPermitida(dataInicio);
  const fim = dayjs(dataFim);

  if (!isPermitidoEditarRemuneracoes(vinculo)) {
    return false;
  }

  const possuiDataDeInicioOuFimInvalidas = !inicio.isValid() || !fim.isValid();
  if (possuiDataDeInicioOuFimInvalidas || inicio.isAfter(fim)) {
    return false;
  }

  const listaRemuneracoesTO = obterListaRemuneracaoOuContribuicoes(vinculo);
  const qtdRemuneracoesEsperadas = obterQuantidadeDeMesesEntreDatas(inicio.toDate(), fim.toDate()) + 1;
  if (listaRemuneracoesTO.length !== qtdRemuneracoesEsperadas) {
    return true;
  }
  const { competenciaInicial, competenciaFinal } = obterPeriodo(listaRemuneracoesTO);
  return inicio.format("MM/YYYY") !== competenciaInicial || fim.format("MM/YYYY") !== competenciaFinal;
}

export const obterPeriodosEditaveis = (vinculo) => {
  let remuneracoes = obterListaRemuneracaoOuContribuicoes(vinculo);
  return getTodosPeriodosEditaveis(remuneracoes);
}

export const obterDataDeInicioOuMenorDataInicioPermitida = (dataInicioISO) => {
  const inicio = dayjs(dataInicioISO);
  const menorDataInicioPermitida = dayjs(competenciaLimiteRemuneracaoEditavel, 'MM/YYYY', true).hour(12);
  if (inicio.isBefore(menorDataInicioPermitida)) {
    return menorDataInicioPermitida;
  }
  return inicio;
}

export const deveLimparRemuneracoes = (vinculo) => {
  const { dataInicio, dataFim } = vinculo;
  const listaRemuneracoesTO = obterListaRemuneracaoOuContribuicoes(vinculo);
  const possuiRemuneracoes = !isEmpty(listaRemuneracoesTO);
  return possuiRemuneracoes && !periodoPermitidoParaCriarRemuneracao(dataInicio, dataFim);
}

const obterPeriodo = (listaRemuneracoesTO) => {
  let remuneracaoInicial = null;
  let remuneracaoFinal = null;

  for (const remuneracaoTO of listaRemuneracoesTO) {
    const dataCorrente = converterCompetenciaEmData(remuneracaoTO.competencia);
    if (!remuneracaoInicial || dataCorrente < remuneracaoInicial.data) {
      remuneracaoInicial = { ...remuneracaoTO, data: dataCorrente };
    }

    if (!remuneracaoFinal || dataCorrente > remuneracaoFinal.data) {
      remuneracaoFinal = { ...remuneracaoTO, data: dataCorrente };
    }
  }
  return {
    competenciaInicial: remuneracaoInicial.competencia,
    competenciaFinal: remuneracaoFinal.competencia,
  };
};

export const transformarEmNumero = (valor) => {
  if (valor && typeof valor === 'string') {
    let valorComPonto = valor.replace(/[^0-9,]/g, '').replace(',', '.');
    return parseFloat(valorComPonto);
  }
  return valor;
}

const periodoPermitidoParaCriarRemuneracao = (dataInicio, dataFim) => {
  const inicio = obterDataDeInicioOuMenorDataInicioPermitida(dataInicio);
  const fim = dayjs(dataFim);
  const dataFimValida = fim.isValid() && fim.isAfter(inicio);
  return inicio.isValid() && dataFimValida;
}

export const obterProximaSequenciaDosVinculos = (
  listaVinculos = [],
  listaVinculosOriginais = []
) => {
  let maiorSequenciaOriginais = obterMaiorSequenciaDosVinculos(listaVinculosOriginais);
  let maiorSequenciaVinculoManual = obterMaiorSequenciaDeVinculoManual(listaVinculos);
  if (maiorSequenciaVinculoManual === 0) {
    return maiorSequenciaOriginais + 1;
  }

  return maiorSequenciaVinculoManual + 1;
};

const obterMaiorSequenciaDosVinculos = (vinculos = []) => (
  vinculos.reduce((maiorSequencia, item) => {
    maiorSequencia =
      item.sequencia > maiorSequencia ? item.sequencia : maiorSequencia;
    return maiorSequencia;
  }, 0))

const obterMaiorSequenciaDeVinculoManual = (listaVinculosTO = []) => (
  listaVinculosTO
    .filter(item => "ADICIONADO_MANUALMENTE" === item.status)
    .reduce((maiorSequencia, item) => {
      maiorSequencia =
        item.sequencia > maiorSequencia ? item.sequencia : maiorSequencia;
      return maiorSequencia;
    }, 0))

export const complementarJsonNovoVinculo = (formVinculo, sequencia) => {

  const { dataInicio, dataFim } = formVinculo;
  const inicio = obterDataDoVinculoComoISO(dataInicio);
  const fim = obterDataDoVinculoComoISO(dataFim);
  const listaRemuneracoesTO = formVinculo.remuneracoes;
  let novoVinculo = montarJsonNovoVinculo(inicio, fim, listaRemuneracoesTO);
  return {
    ...novoVinculo,
    nomeVinculo: formVinculo.nomeVinculo,
    descricaoTipoFiliado: "Empregado",
    tipoVinculoRelacaoTrabalhista: formVinculo.tipoVinculoRelacaoTrabalhista,
    status: "ADICIONADO_MANUALMENTE",
    statusManipulacao: "ADICIONADO_MANUALMENTE",
    sequencia: sequencia
  }
}

const obterDataDoVinculoComoISO = dataComoTextoOuObjetoDate => {
  if (isDate(dataComoTextoOuObjetoDate)) {
    return dataComoTextoOuObjetoDate.toISOString();
  }
  if (isEmpty(dataComoTextoOuObjetoDate)) {
    return null;
  }
  return dataComoTextoOuObjetoDate;
}

export const obterCompetencia = (dataISO) => {
  if (dataISO) {
    const data = dayjs(dataISO)
    if (data.isValid()) {
      return data.format("MM/YYYY")
    }
  }
  return null;
};

export const obterListaRemuneracaoOuContribuicoes = (vinculoTO) => {
  if (vinculoTO) {
    return vinculoTO?.listaRemuneracoesTO || [];
  } else if (vinculoTO?.periodoContribuicaoConsolidadoTO) {
    return vinculoTO.periodoContribuicaoConsolidadoTO.listaContribuicoesConsolidadas || [];
  }

  // recolhimento deveria ser suportado?
  return [];
}

export const isNaoPermitidoEditarVinculo = (vinculo) => {
  return !!vinculo?.periodoBeneficioTO;
}

export const isPermitidoEditarRemuneracoes = (vinculo) => {
  return vinculo?.csTipoFiliado !== 'SEGURADO_ESPECIAL';
}

export const isTipoVinculoSuportaRegimeEspecial = (tipoVinculo) => {
  return [
    "EMPREGADO",
    "CONTRIBUINTE_INDIVIDUAL_AUTONOMO",
    "TRABALHADOR_AVULSO",
    "SERVIDOR_PUBLICO_EFETIVO_RPPS",
    "SERVIDOR_PUBLICO_CONTRATADO_COMISSIONADO",
  ].includes(tipoVinculo);
}

export const compatibilizarPreenchimentoDoTipoVinculo = (listaVinculosTO) => {
  return listaVinculosTO?.map((vinculoTO) => {
    if (vinculoTO?.compatibilizado) {
      return vinculoTO;
    }
    else {
      vinculoTO.compatibilizado = true;
      const isExtratoV3 = vinculoTO.codigoTipoFiliado !== null && vinculoTO.codigoTipoFiliado !== undefined;
      if (isExtratoV3) {
        const tipoFiliado = tipoFiliadoMap[vinculoTO.codigoTipoFiliado];
        vinculoTO.csTipoFiliado = tipoFiliado.sigla;
      }
      if (!vinculoTO.tipoVinculoRelacaoTrabalhista && vinculoTO.codigoTipoFiliado !== undefined && vinculoTO.codigoTipoFiliado !== null) {
        vinculoTO.tipoVinculoRelacaoTrabalhista = converterCodigoTipoFiliadoParaTipoVinculoRelacaoTrabalhista(vinculoTO.codigoTipoFiliado)
      }
      if (!vinculoTO.dataFim && vinculoTO.listaRemuneracoesTO?.length) {
        vinculoTO.dataFim = getMaiorDataFromRemuneracoes(vinculoTO.listaRemuneracoesTO)
      }
      converterTipoFiliadoDaExtratoNoTipoVinculoReconhecidoNoPortal(vinculoTO);
      return compatibilizarPreenchimentoDoTipoFiliado(vinculoTO);
    }
  });
}

/**
 * Compatibilizar o extrato, pois o portal faz uso do tipo de vínculo que unifica alguns tipos de filiados.
 */
const converterTipoFiliadoDaExtratoNoTipoVinculoReconhecidoNoPortal = (vinculoTO) => {
  switch (vinculoTO.tipoVinculoRelacaoTrabalhista) {
    case 'EMPREGADO':
      vinculoTO.tipoVinculoRelacaoTrabalhista = 'EMPREGADO';
      break;
    case 'EMPREGADO_DOMESTICO':
      vinculoTO.tipoVinculoRelacaoTrabalhista = 'EMPREGADO_DOMESTICO';
      break;
    case 'AUTONOMO':
    case 'CONTRIBUINTE_INDIVIDUAL':
    case 'EMPREGADOR':
    case 'EMPREGADOR_RURAL':
    case 'CONTRIBUINTE_INDIVIDUAL_AUTONOMO':
      vinculoTO.tipoVinculoRelacaoTrabalhista = 'CONTRIBUINTE_INDIVIDUAL_AUTONOMO';
      break;
    case 'CONTRIBUINTE_EM_DOBRO':
    case 'ESTUDANTE':
    case 'FACULTATIVO':
      vinculoTO.tipoVinculoRelacaoTrabalhista = 'FACULTATIVO';
      break;
    case 'TRABALHADOR_AVULSO':
      vinculoTO.tipoVinculoRelacaoTrabalhista = 'TRABALHADOR_AVULSO';
      break;
    case 'SEGURADO_ESPECIAL':
    case 'TRABALHADOR_RURAL':
      vinculoTO.tipoVinculoRelacaoTrabalhista = 'TRABALHADOR_RURAL';
      break;
    case 'MILITAR':
    case 'SERVICO_MILITAR':
      vinculoTO.tipoVinculoRelacaoTrabalhista = 'SERVICO_MILITAR';
      break;
    default:
      vinculoTO.tipoVinculoRelacaoTrabalhista = 'OUTROS';
      break;
  }
}

export const compatibilizarPreenchimentoDoTipoFiliado = (vinculoTO) => {
  switch (vinculoTO.tipoVinculoRelacaoTrabalhista) {
    case 'EMPREGADO':
    case 'SERVIDOR_PUBLICO_EFETIVO_RPPS':
    case 'SERVIDOR_PUBLICO_CONTRATADO_COMISSIONADO':
      vinculoTO.csTipoFiliado = 'EMPREGADO';
      vinculoTO.tipoFiliado = 'Empregado';
      vinculoTO.descricaoTipoFiliado = 'Empregado ou Agente Público';
      vinculoTO.codigoTipoFiliado = 1;
      break;
    case 'EMPREGADO_DOMESTICO':
      vinculoTO.csTipoFiliado = 'EMPREGADO_DOMESTICO';
      vinculoTO.tipoFiliado = 'Empregado Doméstico';
      vinculoTO.descricaoTipoFiliado = 'Empregado Doméstico';
      vinculoTO.codigoTipoFiliado = 3;
      break;
    case 'CONTRIBUINTE_INDIVIDUAL_AUTONOMO':
      vinculoTO.csTipoFiliado = 'CONTRIBUINTE_INDIVIDUAL';
      vinculoTO.tipoFiliado = 'Contribuinte Individual';
      vinculoTO.descricaoTipoFiliado = 'Contribuinte Individual';
      vinculoTO.codigoTipoFiliado = 7;
      break;
    case 'FACULTATIVO':
      vinculoTO.csTipoFiliado = 'FACULTATIVO';
      vinculoTO.tipoFiliado = 'Facultativo';
      vinculoTO.descricaoTipoFiliado = 'Facultativo';
      vinculoTO.codigoTipoFiliado = 9;
      break;
    case 'TRABALHADOR_AVULSO':
      vinculoTO.csTipoFiliado = 'TRABALHADOR_AVULSO';
      vinculoTO.tipoFiliado = 'Trabalhador Avulso';
      vinculoTO.descricaoTipoFiliado = 'Trabalhador Avulso';
      vinculoTO.codigoTipoFiliado = 2;
      break;
    case 'TRABALHADOR_RURAL':
      vinculoTO.csTipoFiliado = 'SEGURADO_ESPECIAL';
      vinculoTO.tipoFiliado = 'Segurado Especial';
      vinculoTO.descricaoTipoFiliado = 'Segurado Especial';
      vinculoTO.codigoTipoFiliado = 11;
      break;
    case 'SERVICO_MILITAR':
      vinculoTO.csTipoFiliado = 'MILITAR';
      vinculoTO.tipoFiliado = 'Serviço Militar Obrigatório';
      vinculoTO.descricaoTipoFiliado = 'Serviço Militar Obrigatório';
      vinculoTO.codigoTipoFiliado = 12;
      break;
    case 'OUTROS':
    default:
      vinculoTO.csTipoFiliado = 'NAO_INFORMADO';
      vinculoTO.tipoFiliado = 'Não Informado';
      vinculoTO.descricaoTipoFiliado = 'Não Informado';
      vinculoTO.codigoTipoFiliado = 0;
      break;
  }
  return vinculoTO;
}

export const obterStatusManipulacaoParaAlteracaoDoVinculo = (vinculo) =>
  vinculo.status === "ADICIONADO_MANUALMENTE"
    ? "ADICIONADO_MANUALMENTE"
    : "ALTERADO";

export const converterCodigoTipoFiliadoParaTipoVinculoRelacaoTrabalhista = (codigoTipoFiliado) => {
  switch (codigoTipoFiliado) {
    case 0:
      return 'OUTROS';
    case 1:
      return 'EMPREGADO';
    case 2:
      return 'TRABALHADOR_AVULSO';
    case 3:
      return 'EMPREGADO_DOMESTICO';
    case 4:
    case 5:
    case 6:
    case 7:
    case 10:
      return 'CONTRIBUINTE_INDIVIDUAL_AUTONOMO';
    case 9:
      return 'FACULTATIVO';
    case 11:
      return 'TRABALHADOR_RURAL';
    case 12:
      return 'SERVICO_MILITAR';
    case 13:
      return 'FACULTATIVO';
    default:
      return 'OUTROS';
  }
}

export const getMaiorDataFromRemuneracoes = (listaRemuneracoesTO) => {
  let maiorData = undefined;

  listaRemuneracoesTO.forEach(obj => {
    const [mes, ano] = obj.competencia.split('/');
    //Considera o último dia do mês
    const data = new Date(ano, mes, 0);

    if (!maiorData || data > maiorData) {
      maiorData = data;
    }
  });

  maiorData.setHours(6, 0, 0, 0);
  const dataFormatada = maiorData.toISOString();
  return dataFormatada;
}